import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function LoginIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="currentColor"
                    d="M2.75 11.37C2.34 11.37 2 11.71 2 12.12C2 12.54 2.34 12.87 2.75 12.87H6.8C6.79 12.37 6.79 11.87 6.8 11.37H2.75Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    fill="currentColor"
                    d="M14.4 2.25C9.09999 2.25 7.26999 3.55 6.89999 7.58V7.6C6.82999 8.85 6.8 10.11 6.8 11.37L13.11 11.37L11.47 9.74C11.18 9.44 11.18 8.97 11.47 8.68C11.76 8.38 12.24 8.38 12.53 8.67L15.46 11.59C15.6 11.73 15.68 11.92 15.68 12.12C15.68 12.32 15.6 12.51 15.46 12.65L12.53 15.57C12.39 15.71 12.2 15.79 12 15.79C11.81 15.79 11.62 15.71 11.47 15.57C11.18 15.27 11.18 14.8 11.47 14.51L13.12 12.87L6.8 12.87C6.8 14.05 6.83999 15.23 6.89999 16.42C7.26999 20.45 9.09999 21.75 14.4 21.75C22 21.75 22 18.9 22 12C22 5.1 22 2.25 14.4 2.25Z"
                />
            </g>
        </SvgIcon>
    )
}
